// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2RQ_E","tab":"Tabs_tab__10ULv","tabActive":"Tabs_tabActive__6KSrQ"};